 // var ratingContainer = document.querySelector('.star-rating');
    // var rating = 4.3; // 示例评分
    // var fullStarSrc = '../assets/star-full.png';
    // var halfStarSrc = '../assets/star-half.png';
    // var emptyStarSrc = '../assets/star-empty.png';
    //
    //
    // function renderStars(ratingContainer, rating, fullStarSrc, halfStarSrc, emptyStarSrc) {
    //     // 清空容器中的现有星星
    //     ratingContainer.innerHTML = '';
    //
    //     // 四舍五入评分
    //     rating = Math.round(rating * 2) / 2;
    //
    //     // 渲染完整的星星
    //     for (var i = 1; i <= Math.floor(rating); i++) {
    //         var fullStar = document.createElement('img');
    //         fullStar.src = fullStarSrc;
    //         ratingContainer.appendChild(fullStar);
    //     }
    //
    //     // 如果评分有小数部分，渲染半颗星
    //     if (rating % 1 !== 0) {
    //         var halfStar = document.createElement('img');
    //         halfStar.src = halfStarSrc;
    //         ratingContainer.appendChild(halfStar);
    //     }
    //
    //     // 渲染空星星以填满剩余的星星位置
    //     var emptyStarCount = 5 - Math.ceil(rating);
    //     for (var j = 0; j < emptyStarCount; j++) {
    //         var emptyStar = document.createElement('img');
    //         emptyStar.src = emptyStarSrc;
    //         ratingContainer.appendChild(emptyStar);
    //     }
    // }
    //
    // renderStars(ratingContainer, rating, fullStarSrc, halfStarSrc, emptyStarSrc);

    // $(document).ready(function() {
    var width=$(".custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabList .tabDiv.active").children('a').css('width');
    var left=$(".custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabList .tabDiv.active").children('a').position().left;
    $(" .custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabList .pictureAndTextSlide_Underline").css('width',width);
    $(" .custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabList .pictureAndTextSlide_Underline").css('left',left);

    // });

    function toggleSection(e,index,targetDom){
        // console.log("index==========",index)
        e.preventDefault();
        // 选项卡父级Div
        // var tabtext = '';
        // tabtext = $('#tabtext'+index);
        // // 1.先移除所有tab中active类名
        // $(".tab").removeClass('active');
        // // 2.对点击对象新增active类名
        // tabtext.addClass('active');


        var tabDiv = '';
        tabDiv = $('#custom-pictureAndTextSlide-tabDiv'+index);
        // 1.先移除所有tab中active类名
        $(".tabDiv").removeClass('active');
        // 2.对点击对象新增active类名
        tabDiv.addClass('active');

        $(".custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabTitle").addClass('hidden');
        $(".custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabContent").addClass('hidden');
        var width=$(".custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabList .tabDiv.active").children('a').css('width');
        var left=$(".custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabList .tabDiv.active").children('a').position().left;
        $(" .custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabList .pictureAndTextSlide_Underline").css('width',width);
        $(" .custom-pictureAndTextSlide .z-body .customTextDiv .totalll .leftText .tabList .pictureAndTextSlide_Underline").css('left',left);
        $('#custom-pictureAndTextSlide-tabTitle'+index).removeClass('hidden');
        $('#custom-pictureAndTextSlide-tabContent1'+index).removeClass('hidden');
        $('#custom-pictureAndTextSlide-tabContent2'+index).removeClass('hidden');
        $('#custom-pictureAndTextSlide-tabContent3'+index).removeClass('hidden');
        $('#custom-pictureAndTextSlide-tabContent4'+index).removeClass('hidden');
        $('#custom-pictureAndTextSlide-tabContent5'+index).removeClass('hidden');


        $(".custom-pictureAndTextSlide .z-body .customTextDiv .totalll .rightPicture .picture").addClass('hidden');
        $('#custom-pictureAndTextSlide-picture-'+index).removeClass('hidden');
        // $(".dragImageBlockArrow").css('visibility','visible');
        // $(".dragImageBlockArrow").css('visibility','hidden');

        // $(".pictureAndStarText").addClass('hidden');
        // $('#pictureAndStarText-'+index).removeClass('hidden');


    }


    // Mobile移动端
    $(document).ready(function() {
      if (window.innerWidth < 1024){
          tabOnClick(1);
      }
    })

    function tabOnClick(index){
        $(".tabDivMobile").removeClass('customActiveTabText');
        $("#tabDivMobile-"+index).addClass('customActiveTabText');
        $(".customContentTextAndVideoDiv").css('display','none');
        $("#customContentTextAndVideoDiv-"+index).css('display','flex');
        videoListPause('customContentVideo','customContentVideo-videoPlayButtonMobile')

        $(".activeBottomLineMobile").css('width',$(".customActiveTabText").outerWidth(true));
        $(".activeBottomLineMobile").css('left',$(".customActiveTabText").position().left);


    }




    // laptop 笔记本电脑端
    var divHeight1 = $('.laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-tabDiv.active').outerHeight();

    var width2=$(".laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-tabDiv.active").children('a').css('width');
    var left2=$(".laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-tabDiv.active").children('a').position().left;
    $(" .laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-pictureAndTextSlide_Underline").css('width',width2);
    $(" .laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-pictureAndTextSlide_Underline").css('left',left2);

    $(" .laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-pictureAndTextSlide_Underline").css('top',divHeight1);
    //
    // // %});
    //
    function laptoptoggleSection(event,index){
        // console.log("index==========",index)
        event.preventDefault();
        // 选项卡父级Div
        // var tabtext = '';
        // tabtext = $('#tabtext'+index);
        // // 1.先移除所有tab中active类名
        // $(".tab").removeClass('active');
        // // 2.对点击对象新增active类名
        // tabtext.addClass('active');


        var tabDiv = '';
        tabDiv = $('#laptop-custom-pictureAndTextSlide-tabDiv'+index);
        // 1.先移除所有tab中active类名
        $(".laptop-tabDiv").removeClass('active');
        // 2.对点击对象新增active类名
        tabDiv.addClass('active');

        $(".laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabTitle").addClass('hidden');
        $(".laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabContent").addClass('hidden');
        var divHeight1 = $('.laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-tabDiv.active').outerHeight();
        var width1=$(".laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-tabDiv.active").children('a').css('width');
        var left1=$(".laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-tabDiv.active").children('a').position().left;
        $(".laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-pictureAndTextSlide_Underline").css('width',width1);
        $(".laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-pictureAndTextSlide_Underline").css('left',left1);
        $(" .laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-pictureAndTextSlide_Underline").css('top',divHeight1);
        $('#laptop-custom-pictureAndTextSlide-tabTitle'+index).removeClass('hidden');
        $('#laptop-custom-pictureAndTextSlide-tabContent1'+index).removeClass('hidden');
        $('#laptop-custom-pictureAndTextSlide-tabContent2'+index).removeClass('hidden');
        $('#laptop-custom-pictureAndTextSlide-tabContent3'+index).removeClass('hidden');
        $('#laptop-custom-pictureAndTextSlide-tabContent4'+index).removeClass('hidden');
        $('#laptop-custom-pictureAndTextSlide-tabContent5'+index).removeClass('hidden');


        $(".laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-rightPicture .laptop-picture").addClass('hidden');
        $('#laptop-custom-pictureAndTextSlide-picture-'+index).removeClass('hidden');
        // $(".dragImageBlockArrow").css('visibility','visible');
        // $(".dragImageBlockArrow").css('visibility','hidden');

        // $(".pictureAndStarText").addClass('hidden');
        // $('#pictureAndStarText-'+index).removeClass('hidden');
    }

    var startAutoPlaylaptopCustomPictureAndTextSlideTabsetInterval

    var laptopcurrentIndex = 0;

    function startAutoPlaylaptopCustomPictureAndTextSlideTab() {
        clearInterval(startAutoPlaylaptopCustomPictureAndTextSlideTabsetInterval); // 清除定时器
        startAutoPlaylaptopCustomPictureAndTextSlideTabsetInterval = setInterval(function() {
            var activeLink = $('.laptop-custom-pictureAndTextSlide .laptop-z-body .laptop-customTextDiv .laptop-totalll .laptop-leftText .laptop-tabList .laptop-tabDiv');

            laptopcurrentIndex = (laptopcurrentIndex + 1) % activeLink.length;

            activeLink.removeClass('active').eq(laptopcurrentIndex).addClass('active');

            $(".laptop-tabDiv.active").children('.laptop-tab').trigger('click');
            // 触发下一个链接的点击事件
            // laptoptoggleSection(nextLinkIndex)

        }, 5000); // 每隔5秒进行切换
    }

    function stopAutoPlaylaptopCustomPictureAndTextSlideTab() {
        clearInterval(startAutoPlaylaptopCustomPictureAndTextSlideTabsetInterval); // 清除定时器
    }

    startAutoPlaylaptopCustomPictureAndTextSlideTab();

    $(".laptop-custom-pictureAndTextSlide").hover(
        function() {
            stopAutoPlaylaptopCustomPictureAndTextSlideTab();
        },
        function() {
            startAutoPlaylaptopCustomPictureAndTextSlideTab();
        }
    )